import { z } from 'zod';

const monthYearRegex = /^\d{4}-\d{2}$/;

export const PaymentMethodSchema = z.enum(['CASH', 'ONLINE', 'UPI', 'CARD', 'Online', 'Cash']);

export const CreatePaymentSchema = z.object({
  residentId: z.string().min(1, 'Resident ID is required'),
  bedNumber: z.string().min(1, 'Bed number is required').optional(),
  amount: z
    .number({ invalid_type_error: 'Amount must be a number' })
    .positive('Amount must be greater than 0')
    .max(100000, 'Amount cannot exceed ₹1,00,000'),
  paymentDate: z
    .union([z.string().regex(/^\d{4}-\d{2}-\d{2}$/), z.date()])
    .transform((val) => (typeof val === 'string' ? new Date(val) : val)),
  dueDate: z
    .union([z.string().regex(/^\d{4}-\d{2}-\d{2}$/), z.date()])
    .transform((val) => (typeof val === 'string' ? new Date(val) : val)),
  monthYear: z.string().regex(monthYearRegex, 'Month year must be in YYYY-MM format'),
  paymentMethod: PaymentMethodSchema,
  transactionReference: z.string().max(100).optional().or(z.literal('')),
  remarks: z.string().max(500).optional().or(z.literal('')),
  status: z.enum(['paid', 'pending', 'overdue', 'partial']).default('pending'),
});

export type CreatePaymentInput = z.infer<typeof CreatePaymentSchema>;
